import React from 'react';

interface StatusDisplayProps {
  status: 'error' | 'success' | 'warning' | 'failed' | 'loading';
  message: string | React.ReactNode;
  title?: string;
}

const statusConfig = {
  error: {
    textColor: 'text-[#FF796E]',
    title: 'Error',
  },
  success: {
    textColor: 'text-[#89D286]',
    title: 'Success',
  },
  warning: {
    textColor: 'text-[#FF796E]',
    title: 'Warning',
  },
  failed: {
    textColor: 'text-[#FF796E]',
    title: 'Failed',
  },
  loading: {
    textColor: 'text-sky-300',
    title: 'Loading',
  },
};

export const StatusDisplay: React.FC<StatusDisplayProps> = ({ status, message, title }) => {
  const config = statusConfig[status];
  console.log('>>>[StatusDisplay] status:', status);
  console.log('>>>[StatusDisplay] message:', message);
  console.log('>>>[StatusDisplay] title:', title);

  return <div className={`text-sm opacity-90 w-full ${config.textColor}`}>{message}</div>;
};
